import io from 'socket.io-client'

class SocketClient {
  constructor(url, $store) {
    this.socketUrl = url.replace(/\/$/, '')
    this.$store = $store
  }

  connect() {
    try {
      const config = {
        reconnectionDelay: 10000,
        randomizationFactor: 0,
        transport: ['websocket'],
      }
      this.socket = io(`https://${this.socketUrl}`, config)
      this.socket.on('connect', this.onConnect.bind(this))
      this.socket.on('connect_error', this.onConnectError.bind(this))
      this.socket.on(
        'TRADING_METERING_SUMMARY',
        this.onMeterDataReceived.bind(this)
      )
      this.socket.on('SensorData', this.onSensorDataReceived.bind(this))
      this.socket.on(
        'DeviceStatusChange',
        this.onDeviceStatusChangeReceived.bind(this)
      )
    } catch (err) {
      throw 'Error setting up socket connection to cube: ' + err
    }
  }

  onConnect() {
    this.$store.dispatch('cubeConnectionEstablished')
  }

  onConnectError() {
    this.$store.dispatch('cubeConnectionLost')
  }

  onMeterDataReceived(rawData) {
    // Currently the meter data returned by cubes is in an old format. We need
    // to wrap/convert it to the new format.
    let data = {
      lastMinute: {
        power: {},
      },
    }

    data.lastMinute.power = rawData.aggregatedData

    this.$store.commit('meterDataReceived', data)
  }

  onSensorDataReceived(rawData) {
    this.$store.commit('deviceSensorDataReceived', rawData)
  }

  onDeviceStatusChangeReceived(rawData) {
    this.$store.commit('deviceStatusChangeReceived', rawData)
  }
}

export default SocketClient
